import Symbol from "slotworks/components/matrix/symbol/symbol-component";
import Layers from "slotworks/graphics/layers/layers";
import Result from "slotworks/model/gameplay/records/results/result";
import Contract from "slotworks/utils/contracts/contract";

export default class AbstractSymbolBehaviour {

    public behaviourName: string;

    public validSymbols: string[];

    public animationLayer: Layers;

    protected symbol: Symbol;

    protected behaviourSprite: PIXI.Sprite;

    protected matrixLayer: Layers;

    constructor(symbol: Symbol) {
        this.symbol = symbol;

        this.matrixLayer = this.symbol.getMatrixLayer();
        this.animationLayer = this.symbol.getAnimationLayer();
    }

    public static(): void {
        if (this.behaviourSprite) {
            this.behaviourSprite.visible = false;
        }
    }

    public landAnticipate(): Contract<void> {
        return Contract.empty();
    }

    public land(): Contract<void> {
        return Contract.empty();
    }

    public win(result?: Result): Contract<void> {
        return Contract.empty();
    }

    public cycle(result?: Result): Contract<void> {
        return this.win(result);
    }

    public highlight(result?: Result): Contract<void> {
        return Contract.empty();
    }

    public highlightDim(result?: Result): Contract<void> {
        return Contract.empty();
    }

    public winDim(result?: Result): Contract<void> {
        return Contract.empty();
    }

    public cycleDim(result?: Result): Contract<void> {
        return Contract.empty();
    }

    public expand(x: number = 0, y: number = 0): Contract<void> {
        return Contract.empty();
    }

    public remove(x: number = 0, y: number = 0): Contract<void> {
        return Contract.empty();
    }

    public anticipate(): Contract<void> {
        return Contract.empty();
    }

    public stop(): Contract<void> {
        return Contract.empty();
    }

    public stick() {
        // Stick
    }

    public changeSymbol(): void {
        // Symbol changed into new symbol
    }

    public updateTransform(): void {
        // Reposition "behaviourSprite" (sprite which should match the static sprite's position and size)
        // TODO: Could remove width and height from this?
        if (this.behaviourSprite) {
            const symbolTransform = this.symbol.getTransform();

            const globalPosition = this.matrixLayer.localToGlobal(symbolTransform);
            const localPosition = this.animationLayer.globalToLocal(globalPosition);

            this.behaviourSprite.x = localPosition.x;
            this.behaviourSprite.y = localPosition.y;
            this.behaviourSprite.width = symbolTransform.width;
            this.behaviourSprite.height = symbolTransform.height;

            if (this.symbol.getStackOffset() !== 0) {
                this.behaviourSprite.y -= this.symbol.getStackOffsetY();
            }
        }
    }
}

export interface DefaultSymbolBehaviour {
    behaviourType: typeof AbstractSymbolBehaviour;
    filteredSymbols: string[];
}
